import {
  HStack,
  KdsLink,
  KdsText,
  VStack,
} from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import { useAtom, useAtomValue } from "jotai";
import { useState } from "react";
import { ModalBriefMode } from "@/modals/openBrief/ModalBriefMode";
import {
  isBriefWithAIAtom,
  openBriefAITermsAcceptedAtom,
  userAtom,
} from "@/store";

export const WelcomeHeader = () => {
  const { t } = useTranslate();
  const user = useAtomValue(userAtom);

  const [isConsentModalOpen, setIsConsentModalOpen] = useState(false);
  const [isBriefWithAi, setIsBriefWithAi] = useAtom(isBriefWithAIAtom);
  const acceptedIATerms = useAtomValue(openBriefAITermsAcceptedAtom);

  return (
    <VStack gap="sp-xs" w="full">
      <div
        className="[background:theme(colors.brand.gradient)]"
        style={{
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        <VStack>
          <KdsText size="display-md">
            {t("openBrief.hi")} {user?.firstName}
          </KdsText>

          <KdsText size="display-md">
            {isBriefWithAi
              ? t("openBrief.letsBuild")
              : t("openBrief.letsBuildManual")}
          </KdsText>
        </VStack>
      </div>

      <KdsText color="text-bodyvariant">
        {isBriefWithAi
          ? t("openBrief.startHelper")
          : t("openBrief.startHelperManual")}
      </KdsText>

      <HStack gap="sp-xs2" align="center">
        <KdsText
          color="text-bodyvariant"
          size={isBriefWithAi ? "body-sm" : "subtitle-md"}
        >
          {isBriefWithAi
            ? t("openBrief.needHelpManual")
            : t("openBrief.needHelp")}
        </KdsText>

        <KdsLink
          href="#"
          isUnderline
          size="sm"
          state={isBriefWithAi ? "neutral" : "primary"}
          onPress={() => {
            if (acceptedIATerms) {
              setIsBriefWithAi(!isBriefWithAi);
            } else {
              setIsConsentModalOpen(true);
            }
          }}
        >
          {isBriefWithAi
            ? t("openBrief.needHelpManualLink")
            : t("openBrief.needHelpLink")}
        </KdsLink>
      </HStack>

      <ModalBriefMode
        isOpen={isConsentModalOpen}
        onOpenChange={() => setIsConsentModalOpen(false)}
        isOnlyAcceptAI={true}
      />
    </VStack>
  );
};
